import React, { Dispatch, SetStateAction } from 'react'
import { Box, LoadingOverlay, Modal } from '@mantine/core'
import { DataElements } from '../DataElements'
import { ReportElement} from '../types'

type DataElementsModalProps = {
    elementTree: ReportElement[]
    elementTreeLoading: boolean
    creatingColumnsWithData: boolean
    opened: boolean
    selectedElements: ReportElement[]
    removeElement: (element: ReportElement) => void
    handleSave: () => void
    onClose: () => void
    moveItem: (dragIndex: number, hoverIndex: number) => void
    setSelectedElements: Dispatch<SetStateAction<ReportElement[]>>
    toggleElementSelection: ({ checked, element }: { checked: boolean, element: ReportElement }) => void
}

export const DataElementsModal = ({
    opened,
    selectedElements,
    elementTree,
    elementTreeLoading,
    setSelectedElements,
    handleSave,
    creatingColumnsWithData,
    toggleElementSelection,
    removeElement,
    onClose,
    moveItem,
}: DataElementsModalProps) => {

    return (
        <Modal size='auto' opened={opened} onClose={onClose}>
            <Box w='80vw' maw='1800px' h='80vh'>
                <LoadingOverlay visible={creatingColumnsWithData} />
                <DataElements
                    elementTree={elementTree}
                    elementTreeLoading={elementTreeLoading}
                    toggleElementSelection={toggleElementSelection}
                    removeElement={removeElement}
                    selectedElements={selectedElements}
                    setSelectedElements={setSelectedElements}
                    moveItem={moveItem}
                    onSave={handleSave}
                    onClose={onClose}
                    creatingColumnsWithData={creatingColumnsWithData}
                />
            </Box>
        </Modal>
    )
}